import { createAsyncActionTypes } from 'misc/utils';

const PREFIX = 'customers'

export const LIST = createAsyncActionTypes(`${PREFIX}/LIST`);
export const CREATE = createAsyncActionTypes(`${PREFIX}/CREATE`);
export const RETRIEVE = createAsyncActionTypes(`${PREFIX}/RETRIEVE`);
export const UPDATE = createAsyncActionTypes(`${PREFIX}/UPDATE`);
export const REMOVE = createAsyncActionTypes(`${PREFIX}/REMOVE`);